import {
  getSessionStorage,
  setSessionStorage,
  deleteSessionStorage,
  SESSION_NAME
} from './storage';

/**
 * 保存和操作用户登录信息
 *
 * @class User
 */
class User {
  /**
   * 用户登录
   * 将username，token，expireTime 保存到 sessionStorage 中
   *
   * @memberof User
   */
  login(accessToken) {
    setSessionStorage(SESSION_NAME.token, accessToken);
  }

  /**
   * 判断用户是否登录
   *
   * @memberof User
   */
  isLogin() {
    const accessToken = getSessionStorage(SESSION_NAME.token);
    return !!accessToken;
  }

  getRole() {
    const role = getSessionStorage(SESSION_NAME.role);
    if (role === null) {
      return 0;
    }
    return +role;
  }

  setRole(role) {
    setSessionStorage(SESSION_NAME.role, role);
  }

  /**
   * 用户退出登录
   *
   * @memberof User
   */
  logout() {
    deleteSessionStorage(SESSION_NAME.token);
    deleteSessionStorage(SESSION_NAME.username);
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/utils/user.js